class VariantSelect extends HTMLElement {
  constructor() {
    super();
    this.addToCartButtonSelector = "[js-hb-product-card-cta-btn]";
    this.addEventListener('change', this.onVariantChange);
  }

  onVariantChange(e) {
    this.updateOptions();
    this.currentVariant();
    this.updateButton(e.target);
  }

  getVariantData() {
    return JSON.parse(this.querySelector('[type="application/json"]').textContent);
  }
  
  updateOptions() {
    return [...this.querySelectorAll('[js-size-input]:checked')].map((select) => select.value)
  }

  currentVariant() {
    return this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.updateOptions()[index] === option;
        })
        .includes(false);
    }); 
  }
  updateButton(target) {
    const parentElement = target.closest('[js-hb-product-card]')
    const addtocartBtn = parentElement.querySelector(this.addToCartButtonSelector)
    if (this.currentVariant().available) {
      addtocartBtn.innerText = "Add to Cart"; 
      addtocartBtn.removeAttribute('disabled'); 
      addtocartBtn.style.backgroundColor = '#222222'
    } else {
      addtocartBtn.innerText = "Sold Out"; 
      addtocartBtn.setAttribute('disabled', 'true'); 
      addtocartBtn.style.backgroundColor = '#22222280'
    }
    parentElement.querySelector('input[name="id"]').value = this.currentVariant().id; 
  }
} 

customElements.define('variant-select', VariantSelect);

class hbProductCard extends HTMLElement {
  constructor() {
    super();
    this.form = this.querySelector('[action="/cart/add"]');
    this.switchers = this.querySelectorAll('[js-hb-product-list-link]');
    this.showMores = this.querySelectorAll('[js-hb-show-more-product-option]')
    this.init()
    this.showMoreFun()
  }

  init() {
    this.switchers.forEach((switcher, index) => {
      switcher.addEventListener('click', (e) => {
        e.preventDefault();
        const productHandle = switcher.getAttribute('data-product-handle');
        const url = `${location.origin}/products/${productHandle}?view=productCardAjax`
        this.render(url);
        
      })
    })

    this.form.addEventListener('submit', async (e) => {
      e.preventDefault();
      const formData = this.serialize(this.form)
      this.querySelector('[js-hb-product-card-cta-btn]').classList.add('btn--loading');
      const response = await fetch(theme.routes.cartAdd, {
        method: 'POST',
        body: formData,
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
          'X-Requested-With': 'XMLHttpRequest'
        }
      })
      this.querySelector('[js-hb-product-card-cta-btn]').classList.remove('btn--loading');

      document.dispatchEvent(new CustomEvent('cart:build')); 
      document.dispatchEvent(new CustomEvent('cart:open')); 

    })
  }

  serialize(form) {
    var arr = [];
    Array.prototype.slice.call(form.elements).forEach(function(field) {
      if (
        !field.name ||
        field.disabled ||
        ['file', 'reset', 'submit', 'button'].indexOf(field.type) > -1
      )
        return;
      if (field.type === 'select-multiple') {
        Array.prototype.slice.call(field.options).forEach(function(option) {
          if (!option.selected) return;
          arr.push(
            encodeURIComponent(field.name) +
              '=' +
              encodeURIComponent(option.value)
          );
        });
        return;
      }
      if (['checkbox', 'radio'].indexOf(field.type) > -1 && !field.checked)
        return;
      arr.push(
        encodeURIComponent(field.name) + '=' + encodeURIComponent(field.value)
      );
    });
    return arr.join('&');
  }

  async render(url) {
    let hasColorsOpen = false
    if(this.querySelector("[js-grid-product_options]").classList.contains("showing_all-colors")){
      hasColorsOpen = true
    }
    const previousSelectedSize = this.querySelector("[js-size-input]:checked")
    const response = await fetch(url)
    const html = await response.text()
    const ajaxContainer = new DOMParser()
    .parseFromString(html, 'text/html')
    .querySelector('hb-product-card');
    this.replaceWith(ajaxContainer);
    
    const defaultHandle = ajaxContainer.closest("[js-swiper-slide]")?.getAttribute("data-selected-product-handle");
    if(defaultHandle) {
      ajaxContainer.querySelectorAll(`[data-product-handle="${defaultHandle}"]`)?.forEach( item => item.style.order = -1)
    }
    
    const currentProductSizes = ajaxContainer.querySelectorAll("[js-size-input]")
    currentProductSizes.forEach((currentProductSize) => {
      if(currentProductSize.value == previousSelectedSize.value){
        currentProductSize.click()
      } 
    })
    if(hasColorsOpen == true){
      const productOptions = ajaxContainer.querySelectorAll("[js-hb-list-product-option]")
       productOptions.forEach((productOption) => {
         productOption.classList.add("active_in")
       })
       ajaxContainer.querySelector("[js-grid-product_options]").classList.add("showing_all-colors");
       ajaxContainer.querySelectorAll("[js-hb-show-more-product-option]").forEach((showMoreBtn) => {
        showMoreBtn.classList.add("hide")
       })
   } 
  }

  showMoreFun() {
    this.showMores.forEach(showMore => {
      showMore.addEventListener('click', () => { 
        showMore.classList.add("hide");
        this.querySelector("[js-grid-product_options]").classList.add("showing_all-colors");
        const options = this.querySelectorAll('[js-hb-list-product-option]');
        options.forEach(option => option.style.display = 'inline-block');
      })
    })
  }

}

customElements.define('hb-product-card', hbProductCard);






